// extracted by mini-css-extract-plugin
module.exports = {"doctor-messages-card":"DoctorMessagesCard_doctor-messages-card__2y0zZ","content":"DoctorMessagesCard_content__11Z_y"};